import Axios from "@/plugins/axios";

class NationalityApi {
  getNationalities() {
    return Axios.get("api/public/nationalities").then((response) => {
      return response.data;
    });
  }
}

export default new NationalityApi();
